export enum FundraisingLanguages {
  en = 'en',
  es = 'es',
  fr = 'fr',
  he = 'he',
  y = 'y',
}

export const FundraisingLanguagesList = [
  FundraisingLanguages.en,
  FundraisingLanguages.es,
  FundraisingLanguages.fr,
  FundraisingLanguages.he,
  FundraisingLanguages.y,
];
